module.exports = function(n) { return + n==1 ? 0 : (n==0 || (n%100 > 0 && n%100 < 20)) ? 1 : 2; }
